/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { BigModal } from './BigModal';
import { ModalButton } from './ModalButton';
import { Typography, Grid } from '@mui/material';
import { CustomTextField, SuccessModal } from '../index';
import { apiUrl } from '../../utilities/apiUrl';
import { useEffect, useState } from 'react';
import { useAlert } from '../../providers/AlertContext';

export const ChangePassModal = (props) => {
  const { showAlert } = useAlert();

  // const [username, setUsername] = useState("");
  // const [currentpassword, setCurrentPassword] = useState("");
  const [newpassword, setNewPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');
  const [editSuccessOpen, setEditSuccessOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [isCurrentPassword, setIsCurrentPassword] = useState(false);
  const [isMatchingPassword, setIsMatchingPassword] = useState(false);
  const [passwordTracker, setPasswordTracker] = useState('');
  const emp = props.emp;
  // // Wait for props to update
  // useEffect(() => {
  //   setUsername(props.username);
  //   setCurrentPassword(props.password);
  // },
  //   [props.username, props.password])

  // REG EX FOR PASSWORD VALIDATION
  const atLeastOneUppercase = /[A-Z]/g; // capital letters from A to Z
  const atLeastOneLowercase = /[a-z]/g; // small letters from a to z
  const atLeastOneNumeric = /[0-9]/g; // numbers from 0 to 9
  const atLeastOneSpecialChar = /[#?!@$%^-_&*]/g; // any of the special characters within the square brackets
  const eightCharsOrMore = /.{8,}/g; // eight characters or more

  // PASSWORD TRACKER FOR CRITERIA CHECKING
  const updatePasswordTracker = {
    uppercase: newpassword.match(atLeastOneUppercase),
    lowercase: newpassword.match(atLeastOneLowercase),
    number: newpassword.match(atLeastOneNumeric),
    specialChar: newpassword.match(atLeastOneSpecialChar),
    eightCharsOrGreater: newpassword.match(eightCharsOrMore),
  };

  // // // PASSWORD STRENGTH CHECK
  const passwordStrength = Object.values(updatePasswordTracker).filter(
    (value) => value
  ).length;

  // CHANGE PASSWORD SUBMIT HANDLER
  const handleSubmit = () => {
    // setIsSending(true);

    fetch(apiUrl('/employee/' + emp._id), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstname: emp.firstname,
        lastname: emp.lastname,
        username: emp.username,
        password: newpassword,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setEditSuccessOpen(true);
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleConfirmPassword = async () => {
    const credentials = {
      username: emp.username,
      password: currentPassword,
    };

    try {
      const response = await fetch(apiUrl('/auth/login'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();
      if (data.success) {
        setIsCurrentPassword(true);
      } else {
        showAlert(
          'The password you have entered is incorrect.',
          'warning',
          'Incorrect'
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  // SUCCESSFULLY CHANGED PASSWORD MODAL
  const handleEditSuccessClose = () => {
    setEditSuccessOpen(false);
    // reset values
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setPasswordTracker('');
    setIsCurrentPassword(false);
    setIsMatchingPassword(false);
    window.location.reload();
  };

  // CHANGE PASSWORD CANCEL HANDLER
  const handleCancel = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setPasswordTracker('');
    setIsCurrentPassword(false);
    setIsMatchingPassword(false);
  };

  return (
    <>
      <BigModal open={props.open} onClose={props.onClose}>
        {isCurrentPassword ? (
          <>
            <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
              Change your password:
            </Typography>
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              ></Grid>
              <Grid item xs={12}>
                {/* <CustomTextField
              error={!isCurrentPassword}
              errorMsg={"Please enter your current password."}
              label={"Current Password"}
              onChange={(event) => {
                (event.target.value === currentpassword && event.target.value !== "") ? 
                setIsCurrentPassword(true) : setIsCurrentPassword(false);
              }}
              required={true}
            /> */}
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  error={passwordStrength < 5}
                  errorMsg={'Please enter a valid password'}
                  label={'New Password'}
                  type={'password'}
                  onChange={(event) => {
                    setNewPassword(event.target.value);
                    event.target.value !== ''
                      ? setPasswordTracker(updatePasswordTracker)
                      : setPasswordTracker('');
                    event.target.value === confirmpassword
                      ? setIsMatchingPassword(true)
                      : setIsMatchingPassword(false);
                  }}
                  required={true}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  error={!isMatchingPassword}
                  errorMsg={'Your passwords must match'}
                  label={'Confirm Password'}
                  type={'password'}
                  onChange={(event) => {
                    setConfirmPassword(event.target.value);
                    event.target.value === newpassword &&
                    event.target.value !== ''
                      ? setIsMatchingPassword(true)
                      : setIsMatchingPassword(false);
                  }}
                  required={true}
                />
                <div>
                  <div className="password-strength-meter"></div>
                  <div>
                    {passwordStrength < 5 && 'Must contain: '}
                    {!updatePasswordTracker.uppercase && 'uppercase, '}
                    {!updatePasswordTracker.lowercase && 'lowercase, '}
                    {!updatePasswordTracker.specialChar &&
                      'special character, '}
                    {!updatePasswordTracker.number && 'number, '}
                    {!updatePasswordTracker.eightCharsOrGreater &&
                      'eight characters or more'}
                  </div>
                </div>
              </Grid>
            </Grid>
            <ModalButton
              primaryBtnName="Submit"
              secondaryBtnName="Cancel"
              primaryClickHandler={() => {
                handleSubmit();
                props.onClose();
              }}
              secondaryClickHandler={() => {
                props.onClose();
                handleCancel();
              }}
              // Ensures all fields are properly filled before submit button becomes available
              disable={
                // !currentpassword ||
                !newpassword ||
                passwordStrength < 5 ||
                // !isCurrentPassword ||
                !isMatchingPassword
              }
            />
          </>
        ) : (
          <>
            <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
              Enter your current password:
            </Typography>
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              ></Grid>
              <Grid item xs={12}>
                <CustomTextField
                  error={!currentPassword}
                  errorMsg={'Please enter your current password'}
                  label={'Password'}
                  type={'password'}
                  onChange={(event) => {
                    setCurrentPassword(event.target.value);
                  }}
                  required={true}
                />
              </Grid>
            </Grid>
            <ModalButton
              primaryBtnName="Submit"
              secondaryBtnName="Cancel"
              primaryClickHandler={() => {
                handleConfirmPassword();
              }}
              secondaryClickHandler={() => {
                props.onClose();
                handleCancel();
              }}
              disable={!currentPassword}
            />
          </>
        )}
      </BigModal>
      <SuccessModal
        open={editSuccessOpen}
        onClose={() => {
          setEditSuccessOpen(false);
          handleEditSuccessClose();
        }}
        close={handleEditSuccessClose}
        desc={`You have succesfully changed your password.`}
      />
      <style jsx>
        {`
          .password-strength-meter {
            height: 0.3rem;
            background-color: lightgrey;
            border-radius: 3px;
            margin: 0.5rem 0;
          }

          .password-strength-meter::before {
            content: '';
            background-color: ${[
              'red',
              'orange',
              '#03a2cc',
              '#03a2cc',
              '#0ce052',
            ][passwordStrength - 1] || ''};
            height: 100%;
            width: ${(passwordStrength / 5) * 100}%;
            display: block;
            border-radius: 3px;
            transition: width 0.2s;
          }
        `}
      </style>
    </>
  );
};
